import React, { useEffect } from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { RootState } from '@store/rootReducer';
import { fetchLoginUserProfileFromSessionRequest } from '@store/features/loginUserProfile/actions';
import Loader from '@components/Common/Loader';
import LayoutPresentation from './LayoutPresentation.tsx';

const mapStateToProps = (state: RootState) => ({
  loginUserProfile: state.loginUserProfile,
});

const mapDispatchToProps = {
  fetchLoginUserProfileFromSessionRequest,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const LayoutContainer: React.FC<PropsFromRedux> = ({
  loginUserProfile,
  fetchLoginUserProfileFromSessionRequest,
}) => {
  useEffect(() => {
    fetchLoginUserProfileFromSessionRequest();
  }, []);

  // Only show loader while actually loading or on initial idle state
  if (loginUserProfile.status === 'loading' || loginUserProfile.status === 'idle') {
    return <Loader />;
  }

  // For all other states (succeeded, failed, logout), pass to LayoutPresentation
  // LayoutPresentation will handle routing based on authentication status
  return <LayoutPresentation loginUserProfile={loginUserProfile} />;
};

export default connector(LayoutContainer);
